export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const MONTHS_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function parseISO(iso) {
  if (!iso || typeof iso !== 'string') return null;
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function formatDisplay(iso) {
  const dt = parseISO(iso);
  if (!dt) return '';
  return `${DOW[dt.getDay()]} ${dt.getDate()} ${MONTHS[dt.getMonth()]}`;
}

// build a flat array of cells (day number or null) for a month grid, Sun-first
export function monthMatrix(year, month) {
  const startDow = new Date(year, month, 1).getDay();
  const days = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startDow; i++) cells.push(null);
  for (let d = 1; d <= days; d++) cells.push(d);
  while (cells.length % 7) cells.push(null);
  return cells;
}

// Best-effort convert a human date like "Tue 26 Aug" to an ISO date, for legacy data
export function looseToISO(str, year) {
  if (!str) return null;
  const m = String(str).match(/(\d{1,2})\s+([A-Za-z]{3,})/);
  if (!m) return null;
  const day = +m[1];
  const key = m[2].slice(0, 3).toLowerCase();
  const mon = MONTHS.findIndex(x => x.toLowerCase() === key);
  if (mon < 0 || !day) return null;
  const y = year || new Date().getFullYear();
  return `${y}-${String(mon + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
